/**
 * Hero PDP Block.
 * 
 */

/**
 * Mobile: 
 * Desktop: Hide/show product model photos.
 */

 function initModelPhotos() {
	// console.log('PDP HERO: initModelPhotos');
	// Wire up model buttons to display corresponding photo.
	// Mobile behaves as dropdown, displays currently selected model.
	// Desktop behaves as radio buttons.

	let
		$buttons = $('.models-selector__button'),
		$photos = $('.models-photos__photo'),
		$selectedDisplay = $('.models-selector__selected');

	// Model buttons. Mobile + desktop.
	$buttons.on('click', function() {
		if (!$(this).hasClass('active')) {
			var my_index = $(this).data('model');
			var $myPhoto = $photos.filter('[data-model="'+my_index+'"]');
			$buttons.removeClass('active');
			$(this).addClass('active');
			$photos.not('[data-model="'+my_index+'"]').hide();
			$myPhoto.fadeIn(400);
			$selectedDisplay.html($(this).html());
		}
	});

	// Initialize selector and photos states.
	$buttons.first().addClass('active');
	$selectedDisplay.html($buttons.first().html());
	$photos.hide();
	$photos.first().fadeIn(400);
 }

 let
	$selector = $('.hero-pdp__models-selector'),
	$buttonsPanel = $('.models-selector__buttons'),
	$selectedDisplay = $('.models-selector__selected'),
	buttonsPanelW = 0;

function initMobileModelSelector() {
	// console.log('PDP HERO: initMobileModelSelector()');
	// Called when viewport changes from desktop to mobile.

	// Dropdown button. Mobile only.
	$selectedDisplay.on('click', function() {
		if ($selector.hasClass('active')) {
			$selector.removeClass('active');
			$buttonsPanel.slideUp(200);
		} else {
			$selector.addClass('active');
			$buttonsPanel.slideDown(200);

			setTimeout(()=> {
				// Click anywhere to close dropdown.
				$('html').on('click', function(e) {
					if ($(e.target).parents('.models-selector__buttons').length == 0) {
						$selector.removeClass('active');
						$buttonsPanel.slideUp(200);
						$('html').off();
					}
				});	
			}, 10);
		}
	});

	// Check width of selector panel and use as width for selected/dropdown trigger.
	if (!buttonsPanelW) {
		$buttonsPanel.show();
		buttonsPanelW = $buttonsPanel.innerWidth() + 37;
		$selectedDisplay.css('width', buttonsPanelW+'px');
	}
	$buttonsPanel.hide();
	// console.log('PDP HERO: initMobileModelSelector(): dropdown width: '+buttonsPanelW+'px');
}

 function endMobileModelSelector() {
	// console.log('PDP HERO: endMobileModelSelector()');
	// Disable model selector dropdown and undo dropdown layout.
	// Called when viewport changes from mobile to desktop.

	// Reset dropdown trigger.
	$selector.removeClass('active');
	// Disable click-anywhere-to-close-dropdown.
	$('html').off();
	// Hide dropdown trigger.
	$selectedDisplay.off();
	// Remove inline CSS display.
	$buttonsPanel.css('display', '');
 }

// Explicitly set the height of the scroll-float element's container.
// The container height (bottom edge) determines when float ends.
// Register the float position of scroll-floater by bottom value.
let
	$myFloater = $('.hero-pdp__models'),	// The models block "floats" in desktop.
	$myFloatContainer = $('.hero-pdp-block__container .container-1176'),
	$mySelector = $('.hero-pdp__models-selector'),
	$myHeader = $('.site-header'),

	$window = $(window),
	minBreakpoint = 1024,
	maxBreakpoint = 1320,
	prevWindowW = $window.innerWidth(),	// Inaccurate initial value vs CSS.
	currWindowW = prevWindowW;

function setFloatContainerHeight() {
	// console.log('PDP HERO: setFloatContainerHeight()');
	// In desktop viewports, explicitly set height of scroll-floater container (hero-pdp__models).
	// 		BLADE HEIGHT (hero-pdp__blade) + BENEFITS HEIGHT (hero-pdp__benefits) - MODEL SELECTOR HEIGHT (hero-pdp__models-selector)

	const headerH = 148;
	const marginTop = 30;
	var bladeH = $('.hero-pdp-block .hero-pdp__blade').innerHeight();
	var benefitsH = $('.hero-pdp__benefits').innerHeight();
	var selectorH = $('.hero-pdp__models-selector').height();
	console.log('PDP HERO: setFloatContainerHeight(): selectorH: '+selectorH);
	if (selectorH === null) {
		selectorH = 78;
	}
	var containerH = bladeH + benefitsH - selectorH;
	var floatTop = headerH + selectorH + marginTop;
	$('.hero-pdp__models').css('position', 'absolute');
	$('.hero-pdp__models').css('height', containerH+'px');
	$('.hero-pdp__models').css('top', selectorH+'px');
	$('.hero-pdp__models-photos').css('top', floatTop+'px');
}

function unsetFloatContainerHeight() {
	$('.hero-pdp__models').css('position', 'relative');
	$('.hero-pdp__models').css('height', '');
	$('.hero-pdp__models').css('top', '');
	$('.hero-pdp__models-photos').css('top', '');

}

function dupeProductLogo() {
	// console.log('PDP HERO: dupeProductLogo()');
	// Duplicate product logo and add it to an element/layer that sits on top of the header/main nav.
	// CSS handles positioning.

	var $logoOriginal = $('.hero-pdp__logo');
	var $bladeContentOriginal = $('.hero-pdp__blade_content');
	var logo_html = $logoOriginal.prop('outerHTML');

	logo_html = '<div class="logo-container" style="width:100vw;"><div class="container-1176" style="position:relative;z-index:2000;margin-bottom:-'+$logoOriginal.height()+'px"><div class="hero-pdp__blade_content" style="height:'+$bladeContentOriginal.innerHeight()+'px">' + logo_html + '</div></div></div>';

	$('body').prepend(logo_html);
}

function removeProductLogoDupe() {
	// Remove duplicate product logo.
	// (It's created for desktop and needs to be removed in mobile.)

	$('.logo-container').remove();
}

function initResizeWatcher() {
	// console.log('PDP HERO: initResizeWatcher()');

	$('body').css('overflow','hidden');
	currWindowW = $window.innerWidth();	// Accurate value vs CSS.
	$('body').css('overflow','');

	// Viewport is currently in mobile.
	if ((currWindowW < minBreakpoint) ) {
		// Initialize mobile model selector dropdown.
		initMobileModelSelector();
	}

	// Viewport is currently in desktop.
	if ((currWindowW >= minBreakpoint) ) {
		dupeProductLogo();
		setFloatContainerHeight();
	}

	$window.on('resize', function() {
		$('body').css('overflow','hidden');
		currWindowW = $window.innerWidth();
		$('body').css('overflow','');
		// console.log('PDP HERO: RESIZE: '+currWindowW+'px');

		// Viewport is desktop and less than 1320px (desktop-ml).
		if ((currWindowW >= minBreakpoint) && (currWindowW <= maxBreakpoint)) {

		}

		// Viewport is currently in desktop.
		if ((currWindowW >= minBreakpoint) ) {
			setFloatContainerHeight();
		}

		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= minBreakpoint) && (prevWindowW < minBreakpoint)) {
			// console.log('— mobile —> desktop');
			// Set models position bounded by parent container.
			$myFloater.hide();

			// 10ms delay needed to get selector to full desktop height.
			// (CSS transitions removed from selector and children.)
			setTimeout(()=> {
				setFloatContainerHeight();
				$myFloater.fadeIn(200);
			}, 10);

			// Disable model selector dropdown clicks.
			endMobileModelSelector();

			// Add dupe product logo (to appear in front of header).
			dupeProductLogo();
		}

		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < minBreakpoint) && (prevWindowW >= minBreakpoint)) {
			// console.log('— desktop —> mobile');
			// Set models position relative to parent.
			$myFloater.css('position', 'relative');
			$myFloater.css('top','');
			unsetFloatContainerHeight();

			// Initialize mobile model selector dropdown.
			initMobileModelSelector();

			// Remove dupe product logo.
			removeProductLogoDupe();
		}
		$('body').css('overflow','hidden');
		prevWindowW = $window.innerWidth();
		$('body').css('overflow','');
	});
}

 exports.init = function () {
	// console.log('PDP HERO: exports.init');
    // Run init methods...

	initModelPhotos();
	initResizeWatcher();
};